module.exports = __webpack_public_path__ + "static/media/TJ-Address.7e4f0750.svg";